/**
 * 모바일 바텀시트 (fragments/mobile/sheet.html) — 레거시 팝업 4종 대체.
 *
 * 열기: window 이벤트 'open-sheet' 로 detail 전달
 *   $dispatch('open-sheet', { title, rows: [{ label, value, html? }], links: [{ label, href }] })
 *   - 행 요소에 서버가 th:attr="data-sheet=${JSON}" 로 심어 둔 값을 JSON.parse 해서 그대로 넘기는 것이 계약(추가 API 없음).
 *   - rows[].html === true 면 value 를 x-html 로 렌더 — 서버가 이스케이프해 만든 마크업만 허용(사용자 입력 원문 금지).
 * 닫기: 오버레이 탭 · ESC · 닫기 버튼. 열린 동안 body 스크롤 잠금.
 */
export default () => ({
    isOpen: false,
    title: '',
    rows: [],
    links: [],

    open(detail = {}) {
        this.title = detail.title || '';
        this.rows = Array.isArray(detail.rows) ? detail.rows : [];
        this.links = Array.isArray(detail.links) ? detail.links : [];
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
    },

    close() {
        this.isOpen = false;
        document.body.style.overflow = '';
    },

    /** 빈 값은 '—' */
    text(row) {
        const v = row.value;
        return (v === null || v === undefined || v === '') ? '—' : String(v);
    }
});
